export const FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR = {
    TEXT_BOX_SETTINGS_TITLE: {
        key: 'TEXT_BOX_SETTINGS_TITLE',
        value: 'TextBox Settings'
    },
    FIELD_NAME_LABEL: {
        key: 'FIELD_NAME_LABEL',
        value: 'Field name'
    },
    FIELD_NAME_PLACEHOLDER: {
        key: 'FIELD_NAME_PLACEHOLDER',
        value: 'Enter the field name'
    },
    FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE: {
        key: 'FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE',
        value: 'Field name cannot contain any special characters or spaces other than hyphen(-)'
    },
    FIELD_NAME_EXISTS_ERROR_MESSAGE: {
        key: 'FIELD_NAME_EXISTS_ERROR_MESSAGE',
        value: 'Enter a unique field name. {{fieldName}} field name already exists!'
    },
    MULTILINE_YES_SWITCH: {
        key: 'MULTILINE_YES_SWITCH',
        value: 'Yes'
    },
    MULTILINE_NO_SWITCH: {
        key: 'MULTILINE_NO_SWITCH',
        value: 'No'
    },
    READ_ONLY_YES_SWITCH: {
        key: 'READ_ONLY_YES_SWITCH',
        value: 'Yes'
    },
    READ_ONLY_NO_SWITCH: {
        key: 'READ_ONLY_NO_SWITCH',
        value: 'No'
    },
    IS_MULTILINE_LABEL: {
        key: 'IS_MULTILINE_LABEL',
        value: 'Is MultiLine'
    },
    MAX_LENGTH_LABEL: {
        key: 'MAX_LENGTH_LABEL',
        value: 'Max Length'
    },
    READ_ONLY_LABEL: {
        key: 'READ_ONLY_LABEL',
        value: 'Read Only'
    }
};